import { render, staticRenderFns } from "./ModalDataNote.vue?vue&type=template&id=12c5995d&scoped=true"
import script from "./ModalDataNote.vue?vue&type=script&lang=js"
export * from "./ModalDataNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5995d",
  null
  
)

export default component.exports